/* eslint-disable prettier/prettier */
const initialState = {
  data: [],
  status: 'idle',
}

export const countriesAPIReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'COUNTRY_FETCHING':
      return {
        data: action.payload,
        status: 'success',
        error: null,
      }
    default:
      return state
  }
}
export const statesAPIReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'STATES_FETCHING':
      return {
        data: action.payload,
        status: 'success',
        error: null,
      }
    default:
      return state
  }
}
